var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ClickAwayListener, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BubbleChatIcon, MoreVerticalCircle01Icon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import useTranslate from '../../../../localization/helpers';
import ProtectedElement from '../../../components/ProtectedElement';
import AssetFolderIcon from '../../../icons/components/asset-folder-icon';
var OthersFolder = function (_a) {
    var title = _a.title, details = _a.details, docCount = _a.docCount, processedDocumentCount = _a.processedDocumentCount, processingDocumentCount = _a.processingDocumentCount, failedDocumentCount = _a.failedDocumentCount, unprocessableDocumentCount = _a.unprocessableDocumentCount, onClick = _a.onClick, onStartChat = _a.onStartChat;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.down('sm'));
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(min-width: 1024px) and (max-width: 1024px) and (orientation: landscape)');
    var _b = __read(useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = __read(useState(null), 2), openTooltipDocuments = _c[0], setOpenTooltipDocuments = _c[1];
    useEffect(function () {
        var handleScroll = function (e) {
            var t = e.target;
            if ((t === null || t === void 0 ? void 0 : t.closest) &&
                (t.closest('.MuiTooltip-popper') || t.closest('[data-tooltip-scrollable]'))) {
                return;
            }
            if (openTooltipDocuments !== null)
                setOpenTooltipDocuments(null);
        };
        window.addEventListener('scroll', handleScroll, true);
        return function () {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [openTooltipDocuments]);
    var handleMenuOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var handleClickAway = function () {
        if (openTooltipDocuments !== null) {
            setOpenTooltipDocuments(null);
        }
    };
    var menuItems = [
        {
            text: translate('assets.startChat'),
            icon: BubbleChatIcon,
            onClick: function () { return onStartChat(); },
            color: undefined,
            permission: [],
            divider: false,
            disabled: docCount === 0
        }
    ];
    return (_jsxs(Box, { sx: {
            padding: isXs ? '10px 12px' : '16px 8px 16px 20px',
            gap: '4px',
            borderRadius: '16px',
            border: '1px solid rgba(145, 158, 171, 0.2)',
            cursor: 'pointer'
        }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 1.5, alignItems: 'center', sx: { flex: 1, minWidth: 0 }, onClick: onClick, children: [_jsx(AssetFolderIcon, { width: isXs ? 20 : 40, height: isXs ? 20 : 40 }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { noWrap: true, fontWeight: 500, fontSize: 15, color: 'text.primary', children: title }), _jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx(Tooltip, { open: isXs || isIpadMini || isIpadMiniLandscape
                                                ? openTooltipDocuments === 'others-folder'
                                                : undefined, disableFocusListener: isXs || isIpadMini || isIpadMiniLandscape, disableTouchListener: isXs || isIpadMini || isIpadMiniLandscape, disableHoverListener: isXs || isIpadMini || isIpadMiniLandscape, title: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", processedDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.processingDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: [' ', processingDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.unprocessableDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", unprocessableDocumentCount] })] }) }), _jsx(Box, { display: 'flex', gap: 1, children: _jsxs(Typography, { variant: 'caption', color: theme.palette.grey[400], children: [translate('common.failedDocuments'), ":", _jsxs(Typography, { variant: 'caption', color: theme.palette.common.white, children: ['', " ", failedDocumentCount] })] }) })] }), arrow: true, placement: 'top', slotProps: {
                                                popper: { disablePortal: false }
                                            }, children: _jsx(Typography, { onClick: isXs || isIpadMini || isIpadMiniLandscape
                                                    ? function (e) {
                                                        e.stopPropagation();
                                                        setOpenTooltipDocuments(function (prev) {
                                                            return prev === 'others-folder' ? null : 'others-folder';
                                                        });
                                                    }
                                                    : undefined, noWrap: true, variant: 'body2', color: 'text.secondary', sx: { cursor: 'pointer' }, children: details }) }) })] })] }), _jsx(IconButton, { size: 'small', onClick: function (event) {
                            event.stopPropagation();
                            handleMenuOpen(event);
                        }, children: _jsx(MoreVerticalCircle01Icon, {}) })] }), _jsx(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: function (event) {
                    event.stopPropagation();
                    handleMenuClose();
                }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, onClick: function (event) { return event.stopPropagation(); }, children: menuItems.map(function (menuItem) {
                    var _a, _b;
                    return (_jsx(ProtectedElement, { permissions: (_a = menuItem.permission) !== null && _a !== void 0 ? _a : [], children: _jsxs(MenuItem, { divider: menuItem.divider, sx: { color: menuItem.color }, onClick: function (event) {
                                event.stopPropagation();
                                handleMenuClose();
                                menuItem.onClick();
                            }, disabled: (_b = menuItem.disabled) !== null && _b !== void 0 ? _b : false, children: [_jsx(ListItemIcon, { children: _jsx(menuItem.icon, { fontSize: 20, color: menuItem.color }) }), _jsx(ListItemText, { children: menuItem.text })] }) }, menuItem.text));
                }) })] }));
};
export default OthersFolder;
